// "O que é" a licitação, em uma linha (14/10/2026).
//
// O Lucas abriu a ficha "16 — MUNICIPIO DE CANELA" achando que era o Plano
// Diretor de Drenagem de Canela e viu o prazo de 19/10 — que era da obra do
// emissário de drenagem, outra licitação de Canela (o plano vence em 04/11). As
// duas eram quase iguais na tela: mesma cidade, "drenagem" nas duas, R$ 1,58 mi
// e R$ 1,53 mi; o cabeçalho dizia só número e órgão, e o cartão do quadro
// mostrava as duas primeiras linhas do objeto, que são fórmula de portal.
//
// Esta função tira a fórmula da frente ("Contratação de empresa especializada
// para…", "* Licitação Eletrônica *", "Registro de preços para eventual…") e
// corta na primeira pausa da frase depois de um começo útil. Nunca inventa.
//
// 🚨 CÓPIA da regra do servidor (dre-sistema/lambda/comercial-engine/handlers/
// licitacoesTitulo.js), que escreve os avisos de prazo por e-mail e no sino.
// Os dois lados rodam contra os mesmos casos (tituloDoObjeto.casos.json).
// Mudou aqui, muda lá. Sem lookbehind `(?<!…)`: é erro de sintaxe em Safari
// antigo e derrubaria o portal inteiro.

const TETO = 90;
const MINIMO_UTIL = 10;   // nunca tirar tanto que sobre só um toco
const CORTE_MINIMO = 40;  // a pausa só corta depois de um começo deste tamanho

const MARCAS_INICIO: RegExp[] = [
  /^\*?\s*licita[cç][aã]o\s+eletr[oô]nica\s*\*\s*/i,
  /^[-–—•*.:\s]+/,
  /^\[[^\]]{2,80}\]\s*[-–—:]?\s*/,
  /^produto\/servi[cç]o\s+quant\.?\s+unidade\s+produto\/servi[cç]o\s*:\s*/i,
  /^objeto\s*:\s*/i,
  /^lote\s+(?:[uú]nico|\d+)\s*[-–—:]?\s*/i,
  /^(?:[A-Z]{1,5}\s+){1,3}\d[\d./-]*\s*[-–—]\s*/,
];
const MARCAS_FIM: RegExp[] = [
  /\s*\*\s*(?:https?:\/\/|www\.)[^*]*\*?\s*$/i,
  /\s*\(?\s*https?:\/\/\S+\s*\)?\s*$/i,
  /\s*\*\s*$/,
];

const PREAMBULO = /^(?:obedecid|o\s+munic[ií]pio|a\s+prefeitura|a\s+superintend|a\s+presente|torna|licita[cç][aã]o\s+com\s+crit)/i;
const MARCO_DO_OBJETO = /tem\s+por\s+objeto(?:\s+(?:a|o))?\s+|objeto\s*:\s*|(?=contrata[cç][aã]o\s+d)/i;

const AREA = '(?:engenharia(?:\\s+consultiva)?(?:\\s*(?:,|\\/|\\se\\s)\\s*(?:arquitetura|agrimensura|urbanismo))*'
  + '|[aá]rea\\s+de\\s+engenharia(?:\\s+e\\s+arquitetura)?)';
const FORMULA: RegExp[] = [
  /^registro\s+de\s+pre[cç]os?\s*(?:,\s*)?(?:(?:para|visando|objetivando)\s+(?:[àa]s?\s+|os?\s+)?)?/i,
  /^(?:(?:eventua(?:l|is)|futuras?)\s+(?:e\s+)?)+/i,
  /^contrata[cç][aã]o\s+direta\s*,?\s*(?:por\s+(?:inexigibilidade|dispensa)\s+de\s+licita[cç][aã]o\s*,?\s*)?(?:d[aoe]s?\s+)?/i,
  /^contrata[cç](?:[aã]o|[oõ]es)\s*,?\s*(?:(?:de|dos|das|do|da)\s+)?/i,
  /^(?:,\s*)?(?:por|pelo\s+crit[eé]rio\s+de)\s+(?:t[eé]cnica\s+e\s+pre[cç]o|menor\s+pre[cç]o(?:\s+global)?|maior\s+desconto)\s*,?\s*/i,
  /^(?:,\s*)?em\s+(?:\S+\s+)?lotes?(?:\s+independentes)?\s*,?\s*(?:de\s+)?/i,
  /^servi[cç]o\s+de\s+(?=(?:uma\s+)?empresa)/i,
  /^(?:de\s+)?(?:uma\s+)?(?:empresas?|pessoas?\s+jur[ií]dicas?)(?:\s+ou\s+(?:pessoas?\s+f[ií]sicas?|profissional(?:\s+legalmente)?\s+habilitad[oa]))?\s+/i,
  new RegExp(`^(?:especiali\\w*|qualificad[ao]s?|habilitad[ao]s?|do\\s+ramo|de\\s+${AREA}(?:\\s+especializad[ao]s?)?)(?:\\s+(?:em|na)\\s+${AREA})?\\s*,?\\s*`, 'i'),
  /^ou\s+(?:pessoas?\s+f[ií]sicas?|profissional(?:\s+legalmente)?\s+habilitad[oa])\s*,?\s*/i,
  new RegExp(`^(?:de|em|na)\\s+${AREA}\\s*,?\\s+(?=(?:para|na|no|em|visando)\\s)`, 'i'),
  /^na\s+modalidade\s+pessoa\s+jur[ií]dica\s*,?\s*/i,
  /^(?:,\s*)?pelo\s+crit[eé]rio\s+de\s+menor\s+pre[cç]o(?:\s+global)?\s*,?\s*/i,
  /^com\s+medi[cç][oõ]es\s+dos\s+servi[cç]os\s+efetivamente\s+executados\s*,?\s*/i,
  /^que\s+consiste\s+(?:na|no|em)\s+/i,
  /^[-–—:]\s*/,
  /^(?:dos?|das?)\s+(?=servi)/i,
  /^(?:para|na|no|em|visando|objetivando|com\s+vistas)\s+(?:[àa]s?\s+|os?\s+)?(?=\S)/i,
  /^presta[cç][aã]o\s+(?:de\s+)?(?=servi)/i,
  new RegExp('^servi[cç]os?\\s+(?=t[eé]cnic|especializ|profissio|de\\s+engenharia|cont[ií]nu|continuad|de\\s+natureza)'
    + '(?:(?:t[eé]cnic[oa]s?|especializad[oa]s?|profissionais|cont[ií]nuos?|continuados?'
    + '|de\\s+engenharia(?!\\s+consultiva)(?:\\s*,(?=\\s+(?:de\\s+natureza|para|destinad|visando)))?'
    + '|de\\s+natureza\\s+(?:t[eé]cnica\\s+)?(?:especializada\\s+)?(?:e\\s+)?predominantemente\\s+intelectual\\s*,?|e)\\s+)+'
    + '(?:(?:destinad[oa]s?\\s+(?:[àa]s?|aos?)|para\\s+(?:[àa]s?\\s+|os?\\s+)?|visando\\s+(?:[àa]s?\\s+)?|de|em|na|no)\\s+)?', 'i'),
  /^(?:realizar|executar|elaborar|prestar|fornecer)\s+(?:[àa]s?\s+|os?\s+)?/i,
  /^(?:[àa]\s+|a\s+)?(?:realiza[cç][aã]o|execu[cç][aã]o|elabora[cç][aã]o)\s+(?:de|do|da|dos|das)\s+/i,
];

const PAUSAS = /,|;|:|\s[-–—]\s|\s(?:conforme|conf\.?|de\s+acordo\s+com|nos\s+termos|em\s+atendimento|a\s+fim\s+de|para\s+atender|objetivando|visando|com\s+fornecimento|incluindo|abrangendo|bem\s+como)\s/gi;

const SIGLAS = new Set(['SES', 'SAA', 'SAE', 'SAAE', 'SEMAE', 'DAE', 'DAEE', 'ETA', 'ETE', 'EEE', 'EEAB', 'EEAT', 'PSA', 'SIG',
  'CTM', 'LIDAR', 'RGB', 'GNSS', 'RTK', 'PMSB', 'PDDMAPU', 'PDDU', 'PDD', 'UBS', 'BDI', 'ART', 'TR', 'ETP', 'PNCP', 'CPRM', 'SGB',
  'ANA', 'CORSAN', 'SANEPAR', 'CASAN', 'COPASA', 'SABESP', 'EMBASA', 'CAGECE', 'COMPESA', 'MEI', 'EPP', 'UFSM', 'UFRGS', 'GSD', 'PEC',
  'MDT', 'MDS', 'VANT', 'RPA', 'CAR', 'APP', 'EIA', 'RIMA', 'PRAD', 'PGRS', 'SPU', 'DNIT', 'DER', 'DAER', 'CEHOP', 'SELIC', 'OAE',
  'II', 'III', 'IV', 'VI', 'VII', 'VIII', 'IX', 'XI', 'XII']);
const UFS = 'ac|al|ap|am|ba|ce|df|es|go|ma|mt|ms|mg|pa|pb|pr|pe|pi|rj|rn|rs|ro|rr|sc|sp|se|to';
const LUGAR = /(^|[^A-Za-zÀ-ÿ])(munic[ií]pio\s+de|cidade\s+de|distrito\s+de|localidade\s+de|bairro|rua|avenida|av\.|rio|c[oó]rrego|arroio|lagoa|lago|barragem|bacia\s+(?:hidrogr[aá]fica\s+)?(?:do|da|de|dos|das))\s+([^,;:()]+)/gi;
const LIGA = new Set(['de', 'do', 'da', 'dos', 'das', 'e']);
const PARA = new Set(['para', 'com', 'no', 'na', 'nos', 'nas', 'em', 'conforme', 'através', 'ao', 'aos', 'à', 'às', 'que', 'sob',
  'sobre', 'entre', 'junto', 'por', 'pelo', 'pela', 'incluindo', 'até', 'visando', 'a', 'o', 'os', 'as', 'e', 'de', 'do', 'da',
  'dos', 'das', 'trecho', 'entorno', 'região', 'perímetro', 'sistema']);

const maiuscula = (p: string): string => p.charAt(0).toUpperCase() + p.slice(1);

function semFormula(texto: string): string {
  let t = texto;
  for (let volta = 0; volta < 40; volta++) {
    let achou: RegExpMatchArray | null = null;
    for (const re of FORMULA) {
      const m = t.match(re);
      if (m && m[0].length > 0) { achou = m; break; }
    }
    if (!achou) break;
    const resto = t.slice(achou[0].length).trim();
    if (resto.length < MINIMO_UTIL) break;
    t = resto;
  }
  return t;
}

function cortar(texto: string, teto: number): string {
  let t = texto;
  PAUSAS.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = PAUSAS.exec(t))) {
    if (m.index >= CORTE_MINIMO) { t = t.slice(0, m.index); break; }
  }
  t = t.replace(/[\s.,;:–—-]+$/, '');
  if (t.length <= teto) return t;
  const ate = t.slice(0, teto - 1);
  const espaco = ate.lastIndexOf(' ');
  const base = (espaco > teto * 0.6 ? ate.slice(0, espaco) : ate)
    .replace(/[\s.,;:–—-]+$/, '')
    .replace(/\s+(?:e|de|do|da|dos|das|no|na|nos|nas|em|para|com|a|o|ao|à|por|pelo|pela)$/i, '');
  return `${base}…`;
}

function nomesProprios(t: string): string {
  return t.replace(LUGAR, (_m: string, antes: string, gatilho: string, cauda: string) => {
    const palavras = cauda.split(/(\s+)/);
    const saida: string[] = [];
    let nomes = 0;
    for (let i = 0; i < palavras.length; i++) {
      const p = palavras[i];
      if (!p || /^\s+$/.test(p)) { saida.push(p); continue; }
      const proxima = palavras.slice(i + 1).find((x) => x && !/^\s+$/.test(x));
      if (nomes > 0 && LIGA.has(p) && proxima && !PARA.has(proxima)) { saida.push(p); continue; }
      if (PARA.has(p) || nomes >= 5) { saida.push(palavras.slice(i).join('')); break; }
      saida.push(maiuscula(p));
      nomes++;
    }
    return `${antes}${gatilho} ${saida.join('')}`;
  });
}

function caixa(t: string): string {
  const letras = t.replace(/[^A-Za-zÀ-ÿ]/g, '');
  const maiusculas = letras.replace(/[^A-ZÀ-Þ]/g, '').length;
  if (!letras.length || maiusculas / letras.length < 0.7) return maiuscula(t);
  const baixa = nomesProprios(t.toLowerCase())
    .replace(/[A-Za-zÀ-ÿ]+/g, (p) => (p.length > 1 && SIGLAS.has(p.toUpperCase()) ? p.toUpperCase() : p))
    .replace(new RegExp(`([/–-])\\s?(${UFS})(?![A-Za-zÀ-ÿ])`, 'g'), (_m: string, sep: string, uf: string) => `${sep}${uf.toUpperCase()}`);
  return maiuscula(baixa);
}

/** O que é a licitação, em até ~90 caracteres, a partir do objeto do edital. null sem objeto. */
export function tituloDoObjeto(objeto?: string | null, teto: number = TETO): string | null {
  let t = String(objeto == null ? '' : objeto).replace(/\s+/g, ' ').trim();
  for (let volta = 0; volta < 5; volta++) {
    const antes = t;
    for (const re of MARCAS_INICIO) t = t.replace(re, '');
    for (const re of MARCAS_FIM) t = t.replace(re, '');
    t = t.trim();
    if (t === antes) break;
  }
  if (!t) return null;
  if (PREAMBULO.test(t)) {
    const m = t.match(MARCO_DO_OBJETO);
    if (m && m.index != null && t.length - (m.index + m[0].length) >= 20) t = t.slice(m.index + m[0].length);
  }
  t = cortar(semFormula(t), teto);
  return t ? caixa(t) : null;
}

export interface LicitacaoNomeavel {
  objeto?: string | null;
  numero_edital?: string | null;
  orgao?: string | null;
  cidade?: string | null;
  uf?: string | null;
}

/**
 * Como a licitação é chamada numa confirmação ou num aviso: o que é, onde e qual
 * edital — "Emissário da Drenagem Rua Ruy Vianna Rocha no Bairro São Luiz —
 * Canela/RS, edital 16". Sem objeto, volta ao "edital — órgão" de antes.
 */
export function nomeDaLicitacao(l?: LicitacaoNomeavel | null): string {
  const o = l || {};
  const titulo = tituloDoObjeto(o.objeto, 70);
  if (!titulo) return `${o.numero_edital || 'edital sem número'} — ${o.orgao || 'órgão'}`;
  const onde = [o.cidade, o.uf].filter(Boolean).join('/') || o.orgao || '';
  return `${titulo} — ${[onde, o.numero_edital ? `edital ${o.numero_edital}` : ''].filter(Boolean).join(', ')}`;
}
